export interface TopicArticle {
  id: number;
  title: string;
  category: string;
  date: string;
  readTime: string;
  summary: string;
  image: string;
  content: string[];
  tags: string[];
}

export const topics: TopicArticle[] = [
  {
    id: 1,
    title: "古言漫画为什么让人上头：从宫墙到江湖的情绪密码",
    category: "古言漫谈",
    date: "2026-08-15",
    readTime: "8 分钟",
    summary:
      "一部好的古言漫画，不只是讲一段才子佳人的故事。它把“爱而不得”“久别重逢”“身份悬殊”这些古今相通的情感，藏进一袭华服、一阕词、一盏灯里，让人读完久久难以抽离。",
    image:
      "https://readdy.ai/api/search-image?query=%E5%8F%A4%E5%AE%AB%E8%8A%B1%E6%A0%91%E4%B8%8B%E5%8F%A4%E4%BB%A3%E7%94%B7%E5%A5%B3%E5%AF%B9%E8%A7%86%E7%9A%84%E6%9A%97%E9%87%91%E8%89%B2%E8%B0%83%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E6%BC%AB%E7%94%BB%E6%8F%92%E5%9B%BE%EF%BC%8C%E6%97%A5%E8%90%BD%E6%9A%96%E5%85%89%E8%89%BA%E6%9C%AF%E6%84%9F&width=1200&height=675&seq=topic-guyan-01&orientation=landscape",
    content: [
      "很多人问，古言漫画到底有什么魔力？打开一部《凤归九重》，你可能最初只是被精致的水墨画风吸引，可几话之后，却会为那个从冷宫一路杀回凤位的庶女揪心到凌晨。",
      "答案其实藏在“距离感”里。古言提供了一个与现实足够远、却又足够近的舞台——古代的礼教、身份、门第，放大了爱恨的张力；而人物内心的挣扎、渴望与选择，又与我们当下的情绪一一对应。看得见别人的故事，也照见了自己的心事。",
      "再看宫斗与权谋题材。它吸引人的不只是“赢”，而是那些在刀尖上起舞的智慧与隐忍。一部《江山为聘》，女主以医者之心周旋于党争之间，读者追的是一局局棋，更是一个小人物如何用智慧守护在意之物。这种“逆袭成长”的爽感，正是古风漫画最核心的情绪价值。",
      "而武侠与仙侠，则满足了另一种浪漫——对“自由”与“超越”的想象。《剑起江湖远》里少年负剑出茅庐，一人一马行天涯；《沧澜修仙录》里废柴逆天改命。它们用最瑰丽的想象，承载了最朴素的向往：不被命运定义，凭本事改写人生。",
      "说到底，古言漫画让人上头，是因为它把“情”写进了风骨里。宫墙内的深情、江湖里的快意、仙侠间的执念，都是同一份对美好生活的向往。这也是古风漫画网始终想传递的东西——在纷繁现实里，留一盏为故事亮着的灯。",
    ],
    tags: ["古言", "漫谈", "情绪价值"],
  },
  {
    id: 2,
    title: "宫斗漫画的经典套路与破局之道",
    category: "题材观察",
    date: "2026-08-10",
    readTime: "6 分钟",
    summary:
      "庶女逆袭、皇后驾崩、太医解毒……宫斗漫画有哪些屡试不爽的经典桥段？哪些套路已经让读者审美疲劳？本文梳理宫斗题材的看门道。",
    image:
      "https://readdy.ai/api/search-image?query=%E9%87%91%E9%94%A6%E5%AE%AB%E6%AE%BF%E9%9B%8D%E5%AE%B9%E5%86%85%E9%83%A8%E7%9A%84%E5%8F%A4%E4%BB%A3%E5%AE%AB%E5%A6%83%E9%9B%86%E4%BC%9A%E5%9C%BA%E6%99%AF%EF%BC%8C%E6%9A%97%E9%87%91%E6%B0%B4%E5%A2%A8%E7%94%BB%E6%BC%AB%E7%94%BB%E6%8F%92%E5%9B%BE%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=1200&height=675&seq=topic-gongdou-01&orientation=landscape",
    content: [
      "宫斗题材可以说是古风漫画里最“卷”的一条赛道。《凤归九重》《帝王心术》等作品能长盛不衰，靠的正是对经典套路的娴熟运用与适度破局。",
      "先说经典套路。庶女逆袭、青梅竹马、太医解毒、皇后薨逝引祸……这些桥段几乎是宫斗漫画的“基本盘”。它们之所以好用，是因为天然自带戏剧冲突：身份落差制造阻力，连环计谋提供爽点，生死悬念拉动追更。",
      "但套路用多了，读者也会腻。那些真正能“出圈”的作品，往往在套路之上做了三件事：一是把反派写活，让反派也有逻辑与苦衷；二是把女主写“弱”，允许她失败、迟疑，而不是永远全知全能；三是让“赢”付出代价，让权谋的胜利带着苍凉。",
      "《江山为聘》就是一个很好的例子。女主不是天生赢家，她每走一步都要付出代价，输过、哭过、也想过放弃。正因为有真实的挣扎，最后她登上那个位置时，读者才觉得这一路值得。",
      "对追更的读者来说，看懂套路是为了更好地享受故事。而一部能在套路里长出新东西的宫斗漫画，才是值得你一路追到完结的宝藏。",
    ],
    tags: ["宫斗", "题材", "套路"],
  },
  {
    id: 3,
    title: "武侠漫画与仙侠漫画：两种江湖，两样人生",
    category: "题材观察",
    date: "2026-08-02",
    readTime: "7 分钟",
    summary:
      "武侠讲的是“人”的江湖，一饭之恩、血海深仇，都在一口酒一盏灯里；仙侠讲的是“道”的想象，御剑乘风、逆天改命。两相对照，才更懂古风故事的魅力。",
    image:
      "https://readdy.ai/api/search-image?query=%E5%B1%B1%E9%97%B4%E6%9D%BE%E6%9E%97%E6%9C%88%E5%85%89%E4%B8%8B%E6%8F%90%E5%89%91%E7%9A%84%E4%BE%A0%E5%A3%AB%E4%B8%8E%E9%A3%9E%E5%8D%87%E7%9A%84%E4%BB%99%E5%A5%B3%E5%89%8D%E5%90%8E%E5%B0%8D%E8%A6%96%EF%BC%8C%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E6%BC%AB%E7%94%BB%E6%8F%92%E5%9B%BE%EF%BC%8C%E9%9B%BE%E6%B0%94%E7%BC%AD%E7%BB%95%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=1200&height=675&seq=topic-wuxia-xianxia-01&orientation=landscape",
    content: [
      "在古风漫画的版图里，武侠与仙侠常常被归为一类，但仔细读来，它们其实是两种截然不同的“江湖”。",
      "武侠的江湖是“人”的江湖。这里有恩有怨、有酒有刀，规矩是人定的，情义是人守的。《笑傲明月刀》里少年背负灭门之仇，快意恩仇的背后是沉重的抉择；《龙门客栈》里大漠一隅的客栈，来往皆是命不由己的江湖客。武侠读的是人心与道义，讲究的是“快意恩仇、快刀乱麻”。",
      "仙侠的江湖则更偏“道”的想象。飞剑千里、渡劫飞升、逆天改命，《沧澜修仙录》让读者从微末一路证道，体验凡人成为大能的爽快；《琉璃盏中仙》则在仙凡之间藏了一段温情。仙侠读的是想象力与成长，讲究的是“我心由我不由天”。",
      "两者并不矛盾。好的武侠可以带仙气，好的仙侠也离不开人情。真正打动人的，从来不是设定有多庞大，而是人物有多真实。",
      "无论你喜欢武侠的烈、还是仙侠的逸，在古风漫画网都能找到心头好。这里分类清晰，武侠、仙侠、古言、宫斗、权谋、江湖六条赛道，总有一部能让你一见倾心。",
    ],
    tags: ["武侠", "仙侠", "江湖"],
  },
  {
    id: 4,
    title: "一部古风漫画追更到完结，是什么体验？",
    category: "读者说",
    date: "2026-07-25",
    readTime: "5 分钟",
    summary:
      "从追更到完结，是一段漫长的陪伴。从第一话的心动，到中间几度想弃、又因某个情节重新上头，再到最后一话的怅然若失——这是所有追更党都懂的浪漫。",
    image:
      "https://readdy.ai/api/search-image?query=%E6%9A%97%E9%87%91%E8%89%B2%E8%B0%83%E4%B8%AD%E5%9B%BD%E6%B0%B4%E5%A2%A8%E7%94%BB%E9%A3%8E%E6%A0%BC%E7%9A%84%E5%8F%A4%E4%BB%A3%E5%A5%B3%E5%AD%90%E5%9C%A8%E7%AA%97%E5%89%8D%E5%80%9F%E5%85%89%E9%98%85%E8%AF%BB%E5%8D%B7%E8%BD%B4%EF%BC%8C%E8%89%BA%E6%9C%AF%E6%84%9F&width=1200&height=675&seq=topic-reader-01&orientation=landscape",
    content: [
      "第一次点开《剑起江湖远》的时候，我没想到这一追就是两年。从第1话到第240话完结，这部漫画几乎陪我度过了整个青春期的深夜。",
      "追更是一件很奇妙的事。它不像一次性读完那样爽快，而是把等待变成了陪伴。每周更新的那几分钟，成了平淡日子里的小小仪式感；中间有几话画风突变、剧情拖沓，我也曾想过弃更，可某个清晨突然更新的一话，又让我重新上头。",
      "最难忘的是完结那一夜。看最后一话时，我其实早就猜到结局，可当少年放下剑、江湖归于平静的那一刻，我还是忍不住红了眼眶。不是难过，是一种“陪一段故事走完全程”的满足与怅然。",
      "所以我总跟朋友说，遇到喜欢的古风漫画，别急着一次看完。慢慢追，细细品，让那些故事在时间里发酵，最后你会收获比情节本身更珍贵的记忆。",
      "这也是我想对每一位追更党说的：愿你在古风漫画网追到的每一部作品，都值得你花的时间；愿每一段故事的结局，都配得上这一路的风雨。",
    ],
    tags: ["读者", "追更", "情感"],
  },
];

export const faqs = [
  {
    q: "古风漫画网支持哪些题材的漫画？",
    a: "我们专注古风国漫，涵盖古言、宫斗、权谋、武侠、仙侠、江湖六大题材，同时收录网文改编、热门新番与经典老番，分类清晰，可按题材直达心仪作品。",
  },
  {
    q: "漫画多久更新一次？在哪里看最新更新？",
    a: "热门作品基本每日更新，首页的「今日新番」与「最新更新」区块会实时汇总当天上新的作品与章节，方便你第一时间追更收藏。",
  },
  {
    q: "如何收藏我喜欢的漫画？",
    a: "进入漫画详情页点击「加入收藏」即可把作品收录进个人追更列表，后续再也不用担心找不到更新章节。",
  },
  {
    q: "看漫画需要付费吗？",
    a: "我们提供大量免费章节供读者畅读，部分连载作品依据平台规则可能涉及部分章节解锁，具体以作品页面说明为准。",
  },
  {
    q: "在古风漫画网看漫画有哪些端支持？",
    a: "网站为响应式设计，电脑、平板、手机均可正常访问与阅读，移动端菜单与阅读体验同样流畅。",
  },
  {
    q: "遇到链接打不开或内容有误怎么办？",
    a: "你可以通过「联系我们」页面反馈，我们会有专人及时排查修复，确保阅读体验稳定顺畅。",
  },
];